import { Arrow } from 'shared/icons';

export const ScrollToTopArrow = () => {
  const handleClick = () =>
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

  return (
    <button type="button" onClick={handleClick} aria-label="Scroll to top" data-qa="scroll_to_top">
      <Arrow />
    </button>
  );
};
